import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import './Header.css';

const Header: React.FC = () => {
  const { user, signOut } = useAuth();
  const { total } = useCart();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/jkprintslogo.jpeg" alt="JK Prints" className="logo-image" />
          </Link>

          <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
            <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link to="/products" onClick={() => setMobileMenuOpen(false)}>Products</Link>
            <Link to="/custom-order" onClick={() => setMobileMenuOpen(false)}>Custom Order</Link>
            {user?.isAdmin && (
              <Link to="/admin" onClick={() => setMobileMenuOpen(false)}>Admin</Link>
            )}
          </nav>

          <div className="header-actions">
            <Link to="/cart" className="cart-link">
              <span className="icon-cart"></span>
              {total > 0 && <span className="cart-count">({total})</span>}
            </Link>

            {user ? (
              <div className="user-menu">
                <span className="user-name">{user.displayName || user.email}</span>
                <button onClick={handleSignOut} className="btn btn-secondary">Sign Out</button>
              </div>
            ) : (
              <div className="auth-buttons">
                <Link to="/login" className="btn btn-secondary">Login</Link>
              </div>
            )}

            <button 
              className="mobile-menu-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
